import styled from '@emotion/styled';
import pym from 'pym.js';
import { useState, useCallback, useEffect } from 'react';

import Contents from '../../location/Popup/Contents';
import trySubmitZip from '../../location/Popup/trySubmitZip';
import { getZipInfo } from '../../location/locales';

const Container = styled.div`
  padding: 15px;
`;

/*
 * this is now ONLY used as an embeddable widget
 * the non-embeddable version is in the location folder
 */
const CrossingLocale = ({ availableLocales = [], locale, zip, zipRequired }) => {
  useEffect(() => {
    const pymChild = pym.Child({ polling: 100 });

    return () => pymChild.remove();
  }, []);

  // TODO: '*' origin should be replaced by owenscorning.com once this is deployed, leaving like this for live testing
  const passMessage = (action, meta = null) => window.parent.postMessage({ type: 'locationChange', action, meta }, '*');

  const [selectedLocale, setSelectedLocale] = useState(locale);
  const [currentZip, setZip] = useState(zip);
  const [zipValid, setZipValid] = useState(true);

  const setLocaleCode = localeCode => setSelectedLocale(availableLocales.filter(l => l.code === localeCode)[0]);

  const zipInfo = getZipInfo(selectedLocale.code);

  const handler = useCallback(() => {
    trySubmitZip(
      selectedLocale,
      currentZip,
      zipRequired,
      (loc, zi) => passMessage('forward', { zip: zi, locale: loc.code }),
      () => setZipValid(false)
    );
  }, [currentZip, selectedLocale.code]);

  const modalProps = {
    availableLocales,
    error: !zipValid,
    onSubmit: handler,
    showLocale: true,
    onChangeZip: setZip,
    showZip: !!zipInfo && zipRequired,
    selectedLocale,
    translationLocale: selectedLocale,
    zip: currentZip,
    setLocaleCode,
  };
  return (
    <Container className="location-modal" style={{ padding: '15px' }}>
      <Contents {...modalProps} />
    </Container>
  );
};

export default CrossingLocale;
